import { render } from "./MessageHeader.vue?vue&type=template&id=75105919&scoped=true"
import script from "./MessageHeader.vue?vue&type=script&lang=js"
export * from "./MessageHeader.vue?vue&type=script&lang=js"

import "./MessageHeader.vue?vue&type=style&index=0&id=75105919&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75105919"]])

export default __exports__